import { useEffect, useRef, useState } from "react";
import { X } from "lucide-react";
import TakeoffPanel from "./TakeoffPanel";
import PlansPanel from "./PlansPanel";
import LibraryPanel from "./LibraryPanel";
import LayersPanel from "./LayersPanel";
import { useTakeoff } from "./store";

/** 390 px right inspector — Takeoff / Plans / Company Library tabs. */
export default function Inspector(props) {
  const { design } = useTakeoff();
  const [tab, setTab] = useState("takeoff");
  // Design tab: the CAD Layers panel is the home panel once the drawing is ready.
  const landedOnLayers = useRef(false);
  useEffect(() => { if (design && props.cad && !landedOnLayers.current) { landedOnLayers.current = true; setTab("layers"); } }, [design, props.cad]);
  // the pipe scale-gate toast's "Set scale" action lands here: jump to the
  // Takeoff tab and focus the scale preset control
  useEffect(() => {
    const h = () => {
      setTab("takeoff");
      setTimeout(() => document.querySelector('[data-testid="takeoff-scale-preset"]')?.focus(), 120);
    };
    window.addEventListener("takeoff:focus-scale", h);
    return () => window.removeEventListener("takeoff:focus-scale", h);
  }, []);
  const tabs = [
    ["takeoff", "Takeoff"],
    ["plans", "Plans"],
    ...(props.cad ? [["layers", "Layers"]] : []),
    ["library", "Company Library"],
  ];
  // a CAD drawing closed -> leave the Layers tab
  useEffect(() => { if (!props.cad && tab === "layers") setTab("takeoff"); }, [props.cad, tab]);
  return (
    <div className="flex w-[390px] shrink-0 flex-col border-l border-slate-200 bg-[#f8fafc] shadow-[-4px_0_12px_rgba(11,23,42,0.06)]" data-testid="takeoff-inspector">
      <div className="flex shrink-0 bg-[#0b172a]">
        {tabs.map(([k, l]) => (
          <button key={k} onClick={() => setTab(k)} data-testid={`inspector-tab-${k}`}
            aria-pressed={tab === k}
            className={`flex-1 px-2 py-2.5 text-[10px] font-semibold uppercase tracking-widest transition-colors ${tab === k ? "bg-[#f97316] text-[#0b172a]" : "text-slate-400 hover:text-white"}`}>
            {l}
          </button>
        ))}
        {/* closes the WHOLE panel (not just a folder) — drawing takes over;
            the floating Plans button reopens it */}
        <button onClick={props.onClose} data-testid="inspector-close-btn" aria-label="Close panel" title="Close panel — the drawing gets the full width"
          className="shrink-0 px-3 text-slate-400 hover:bg-white/10 hover:text-white">
          <X className="h-4 w-4" />
        </button>
      </div>
      <div className="min-h-0 flex-1">
        {tab === "takeoff" && (
          <TakeoffPanel
            drawing={props.drawing} pageNum={props.pageNum} pageState={props.pageState}
            pageItems={props.pageItems} measurable={props.measurable}
            activeItemId={props.activeItemId} onPickItem={props.onPickItem}
            selection={props.selection} setSelection={props.setSelection}
            applyPreset={props.applyPreset} startCustomScale={props.startCustomScale}
            overlay={props.overlay} setOverlay={props.setOverlay} pageText={props.pageText}
          />
        )}
        {tab === "plans" && <PlansPanel drawing={props.drawing} openDrawing={props.openDrawing} pageNum={props.pageNum} />}
        {tab === "layers" && props.cad && <LayersPanel drawing={props.drawing} pageNum={props.pageNum} cad={props.cad} onCadChange={props.onCadChange} cadLayer={props.cadLayer} onCadLayer={props.onCadLayer} cadDraw={props.cadDraw} onCadDraw={props.onCadDraw} />}
        {tab === "library" && <LibraryPanel />}
      </div>
    </div>
  );
}
